var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "button",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("i", {
        staticClass: "icon-xl",
        class: _vm.icon,
        attrs: { "aria-hidden": "true" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }